<template>
  <aside
    class="fixed shadow-md z-20 transition-all duration-300 ease-in-out h-screen bg-white dark:bg-dark-900 border-r border-r-gray-300 dark:border-dark-700 transform lg:translate-x-0 lg:visible"
    :class="[
      open ? 'translate-x-0 visible' : '-translate-x-full invisible',
      open ? 'w-[18.75rem]' : 'w-[5.75rem]',
    ]"
  >
    <HealthSidebarItem />
  </aside>
</template>

<script lang="ts" setup>
  import { useI18n } from "vue-i18n";
  import { useSidebar } from "@/shared/composables/useSidebar";
  import HealthSidebarItem from "@/shared/components/layout/sidebar/HealthSidebarItem.vue";

  const { t } = useI18n();

  const { open } = useSidebar();
</script>

<style scoped>
  aside {
    transition: width 0.3s ease-in-out;
  }
</style>
